import React, { useState, useEffect, useCallback } from 'react'

import request from 'Request'

import { downloadText } from 'Helpers'

import Link from 'Components/Link'
import Tab from './Tab'

export default () => {
  const downloadPatients = useCallback(async () => {
    // TODO: Handle error
    const response = await request.post('/reports/activity/patients')
    downloadText(
      response.headers['content-disposition'].split('filename=')[1],
      response.data
    )
  })

  const downloadJourneysNotStarted = useCallback(async () => {
    // TODO: Handle error
    const response = await request.post('/reports/activity/journeys')
    downloadText(
      response.headers['content-disposition'].split('filename=')[1],
      response.data
    )
  })

  const [statistics, setStatistics] = useState({
    patients: 'Loading...',
    journeysNotStarted: 'Loading...',
    formsCompleted: 'Loading...',
    formsSent: 'Loading...'
  })

  useEffect(async () => {
    const getPatientsPromise = request.get('/info/patients/count')
    const getJourneysNotStartedPromise = request.get(
      '/info/journeys/count-not-started'
    )
    const getFormsCompletedPromise = request.get(
      '/info/forms/count?completed=true'
    )
    const getFormsSentPromise = request.get('/info/forms/count')

    setStatistics({
      patients: (await getPatientsPromise).data,
      journeysNotStarted: (await getJourneysNotStartedPromise).data,
      formsCompleted: (await getFormsCompletedPromise).data,
      formsSent: (await getFormsSentPromise).data
    })
  }, [])

  return (
    <Tab.Container>
      <Tab.Tabs>
        <Tab.Tab header="Total Patients" value={statistics.patients}>
          <Link
            onClick={downloadPatients}
            style={{ textAlign: 'right', textDecoration: 'underline' }}
          >
            Download All Patients
          </Link>
        </Tab.Tab>
        <Tab.Tab
          header="Journeys Not Started"
          value={statistics.journeysNotStarted}
        >
          <Link
            onClick={downloadJourneysNotStarted}
            style={{ textAlign: 'right', textDecoration: 'underline' }}
          >
            Download Journeys Not Started
          </Link>
        </Tab.Tab>
        <Tab.Tab header="Forms Completed" value={statistics.formsCompleted} />
        <Tab.Tab header="Forms Sent" value={statistics.formsSent} />
      </Tab.Tabs>
    </Tab.Container>
  )
}
